import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { commissionRateValidator }                from '../../validators/CustomValidators';
import { vendPriceValidator }                from '../../validators/CustomValidators';

//components
import { FullServiceCustomerTypeDropdownComponent }         from '../../components/DomainData/FullServiceCustomerTypeDropdown.component';
import { VendPackageDropdownComponent }         from '../../components/DomainData/VendPackageDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-fullservicepackageconfig-edit',
  templateUrl: './FullServicePackageConfigEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => FullServicePackageConfigEditComponent)}]
})
export class FullServicePackageConfigEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    @ViewChild(FullServiceCustomerTypeDropdownComponent) public fullServiceCustomerTypeDropdownComponent: FullServiceCustomerTypeDropdownComponent;
    @ViewChild(VendPackageDropdownComponent) public vendPackageDropdownComponent: VendPackageDropdownComponent;

    form: FormGroup;

    @Input() public record: ent.PackageConfig;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'package' : '',
          'customerType' : '',
          'performanceBasedPay' : '',
          'commissionRate' : '',
          'minimumVendPrice' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
      this.form.controls.package.setValidators(dropDownValidator);
      this.form.controls.customerType.setValidators(dropDownValidator);
      this.form.controls.commissionRate.setValidators([commissionRateValidator]);
      this.form.controls.minimumVendPrice.setValidators([vendPriceValidator]);
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    packageChange(event: any){
        
      this.record.PackageID = event;
    }

    customerTypeChange(event: any){
        
      this.record.CustomerTypeID = event;
    }

    showCommissionRate(record: ent.PackageConfig): boolean{
      return record.PerformanceBasedPay == null || record.PerformanceBasedPay == false;
    }

    performanceBasedPayChange(checked: boolean){
        
      if (checked){
        this.form.controls.commissionRate.clearValidators();
      }
      else{
        this.form.controls.commissionRate.setValidators([commissionRateValidator]);
      }
      this.form.controls.commissionRate.updateValueAndValidity()
      
  }
} 